import * as React from 'react';
const SvgGoogleAnalytics = (props) => (
  <svg viewBox="0 0 62 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity={0.995} fillRule="evenodd" clipRule="evenodd">
      <path
        d="M52.632.011c3.541-.153 6.243 1.268 8.106 4.262.534.947.883 1.96 1.046 3.036a6316.4 6316.4 0 0 1-.058 54.003c-.56 3.266-2.35 5.552-5.375 6.86-3.999 1.313-7.282.31-9.849-3.007a8.853 8.853 0 0 1-1.569-4.32 6172.54 6172.54 0 0 1 .059-53.42C45.547 4.378 47.203 2.17 49.96.8a9.882 9.882 0 0 1 2.672-.788Z"
        fill="#F9AB00"
      />
      <path
        d="M30.088 25.933c3.66-.133 6.4 1.385 8.222 4.553.49.956.799 1.968.93 3.036.038 9.283.038 18.566 0 27.848-.488 2.803-1.95 4.915-4.388 6.334-2.343 1.2-4.745 1.336-7.205.41a8.017 8.017 0 0 1-3.573-3.241 13.273 13.273 0 0 1-1.627-5.605c-.039-8.484-.039-16.97 0-25.454.574-3.69 2.598-6.19 6.072-7.502a15.272 15.272 0 0 1 1.569-.38ZM7.776 51.737c3.907-.106 6.725 1.587 8.454 5.08 1.218 3.141.831 6.06-1.162 8.757-2.4 2.724-5.374 3.667-8.92 2.831-2.976-.948-4.923-2.923-5.839-5.926-.817-3.323-.013-6.174 2.411-8.553a9.029 9.029 0 0 1 5.056-2.189Z"
        fill="#E37300"
      />
    </g>
  </svg>
);
export default SvgGoogleAnalytics;
